module.exports = __webpack_public_path__ + "img/group_part1_pc.dfb65c1e.jpg";